var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdTopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#FFF9EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.9954 18.1092C32.9145 19.0272 33.8336 19.9453 33.8336 19.9453C35.0715 18.7087 35.0778 17.4784 33.8524 16.2543C32.9333 15.3363 32.3206 14.7242 32.3238 14.1091C30.7763 15.6548 30.77 16.8851 31.9954 18.1092Z",
    fill: "url(#paint0_linear_4432_32212)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.2637 25.7972C32.2668 25.182 32.8858 24.5637 33.8142 23.6363C35.0522 22.3997 35.0585 21.1694 33.8331 19.9453C33.8331 19.9453 32.9046 20.8727 31.9761 21.8002C30.7382 23.0368 30.7319 24.2671 32.2637 25.7972Z",
    fill: "url(#paint1_linear_4432_32212)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.584 7.37695C24.9681 7.38009 24.3554 6.76806 23.4364 5.85002C22.211 4.62596 20.9793 4.63223 19.7413 5.86881C19.7413 5.86881 20.6604 6.78685 21.5794 7.70489C22.8048 8.92894 24.0365 8.92268 25.584 7.37695Z",
    fill: "url(#paint2_linear_4432_32212)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M17.8843 7.72353C18.8127 6.79609 19.7412 5.86865 19.7412 5.86865C18.5158 4.6446 17.2841 4.65086 16.0462 5.88745C15.1177 6.81488 14.4987 7.43317 13.8829 7.43631C15.4146 8.96637 16.6463 8.96011 17.8843 7.72353Z",
    fill: "url(#paint3_linear_4432_32212)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.3238 14.1088C33.8713 12.5631 33.8775 11.3328 32.0394 9.49672L30.2013 7.66063C28.3632 5.82455 27.1315 5.83082 25.584 7.37654C26.1999 7.37341 27.1323 8.27806 28.3443 9.51551L30.1825 11.3516C31.3948 12.5887 32.3269 13.4937 32.3238 14.1088Z",
    fill: "url(#paint4_linear_4432_32212)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8828 7.43604C12.351 5.90597 11.1194 5.91223 9.26242 7.76711L7.40548 9.62198C5.54855 11.4769 5.54227 12.7072 7.07404 14.2372C7.07718 13.6221 7.99237 12.6814 9.24361 11.4581L11.1005 9.60319C12.3514 8.37952 13.267 7.43917 13.8828 7.43604Z",
    fill: "url(#paint5_linear_4432_32212)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.455 32.5981C26.9867 34.1281 28.2184 34.1219 30.0753 32.267L31.9323 30.4121C33.7892 28.5573 33.7955 27.3269 32.2637 25.7969C32.2606 26.412 31.3454 27.3527 30.0942 28.576L28.2372 30.4309C26.9863 31.6546 26.0708 32.5949 25.455 32.5981Z",
    fill: "url(#paint6_linear_4432_32212)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 13.4531H18.7775C20.291 13.4531 21.6116 13.7441 22.7392 14.3231C23.8669 14.9051 24.7418 15.7377 25.3613 16.8238C25.9809 17.91 26.2906 19.1776 26.2906 20.6296C26.2906 23.0352 25.6195 24.8589 24.2744 26.0948C22.9321 27.3337 21.0844 27.9502 18.7368 27.9502H13.71V13.4502V13.4531ZM19.0302 24.3432C20.0356 24.3432 20.8073 24.0119 21.348 23.3464C21.8887 22.6838 22.1605 21.7763 22.1605 20.6296C22.1605 19.6069 21.886 18.757 21.3399 18.0771C20.7937 17.3971 20.041 17.0601 19.09 17.0601H17.7586V24.3403H19.0302V24.3432Z",
    fill: "url(#paint7_linear_4432_32212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4432_32212",
    x1: 34.1621,
    y1: 15.9454,
    x2: 31.9981,
    y2: 18.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4432_32212",
    x1: 34.9054,
    y1: 21.0165,
    x2: 31.1957,
    y2: 24.7303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4432_32212",
    x1: 23.7461,
    y1: 5.54107,
    x2: 21.582,
    y2: 7.7075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4432_32212",
    x1: 18.6691,
    y1: 4.79772,
    x2: 14.9593,
    y2: 8.51159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4432_32212",
    x1: 31.1207,
    y1: 8.57904,
    x2: 28.9567,
    y2: 10.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4432_32212",
    x1: 12.8107,
    y1: 6.3651,
    x2: 6.00949,
    y2: 13.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4432_32212",
    x1: 33.3361,
    y1: 26.868,
    x2: 26.5349,
    y2: 33.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4432_32212",
    x1: 13.71,
    y1: 20.6994,
    x2: 26.2906,
    y2: 20.6994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdTopupIcon);
export default __webpack_public_path__ + "static/media/fyxd-topup-icon.59ff54360dcb737a9a3ba852ae4085ac.svg";
export { ForwardRef as ReactComponent };